export const OperacionNOTESFields = {
    CodOperacionNOTES: 'codOperacionNOTES',
    CodPais: 'codPais',
    NombrePais: 'nombrePais',
    CodUnidadNegocio: 'codUnidadNegocio',
    UnidadNegocio: 'descUnidadNegocio',
    CodSectorComercial: 'codSectorComercial',
    SectorComercial: 'descSectorComercial',
    FechaSolicitud: 'fechaSolicitud',
    FechaVencimiento: 'fechaVencimiento',
    CodEstado: 'codEstado',
    DescEstado: 'descEstado',
    FechaAprobacion: 'fechaAprobacion',
    FechaAlta: 'fechaAlta',
    IdUsuarioAlta: 'idUsuarioAlta',
    NombreUsuarioAlta: 'nombreUsuarioAlta',
    ApellidoUsuarioAlta: 'apellidoUsuarioAlta',
    MailUsuarioAlta: 'mailUsuarioAlta',
    IdUsuarioUltMod: 'idUsuarioUltMod',
    NombreUsuarioUltMod: 'nombreUsuarioUltMod',
    ApellidoUsuarioUltMod: 'apellidoUsuarioUltMod',
    MailUsuarioUltMod: 'mailUsuarioUltMod',
    
    // form de secciones
    TipoNota: 'tipoNota',
    DescTipoNota: 'descTipoNota',
    TipoVirtualNota: 'tipoVirtualNota',
    Cliente: 'cliente',
    CapitalASuscribir: 'capitalASuscribir',
    Moneda: 'moneda',
    Vencimiento: 'vencimiento',
    FechaEmision: 'fechaEmision',
    Emisor: 'emisor',
    Subyacentes: 'subyacentes',
    ObsSubyacentes: 'obsSubyacentes',
    Cupon: 'cupon',
    FrecuenciaPago: 'frecuenciaPago',
    CondicionPago: 'condicionPago',
    ObsCupon: 'obsCupon',
    Participacion: 'participacion',
    FormaParticipacion: 'formaParticipacion',
    DescripcionParticipacion: 'descripcionParticipacion',
    ObsParticipacion: 'obsParticipacion',
    TipoProteccion: 'tipoProteccion',
    NivelProteccion: 'nivelProteccion',
    DescripcionProteccion: 'descripcionProteccion',
    ObsProteccion: 'obsProteccion',
    BarreraRescateAnticipado: 'barreraRescateAnticipado',
    CondicionRescateAnticipado: 'condicionRescateAnticipado',
    FrecuenciaObservacion: 'frecuenciaObservacion',
    ObsRescateAnticipado: 'obsRescateAnticipado',
    ArchivoGrafico: 'archivoGrafico',

    // campos bool para controlar que campos son obligatorios
    TieneCupon: 'tieneCupon',
    TieneParticipacion: 'tieneParticipacion',
    TieneRescateAnticipado: 'tieneRescateAnticipado',

    //
    EstadoFinalizado: 'estadoFinalizado',
    IdMensaje: 'idMensaje',
    PermiteEditarOperacion: 'permiteEditarOperacion',
    PermiteEliminarOperacion: 'permiteEliminarOperacion',
    Parametros: 'parametros'
} as const;

export const OperacionNOTESParametroFields = {
    IdParametro: 'idParametro',
    Titulo: 'titulo',
    Valor: 'valor',
    Orden: 'orden'
} as const;